export default "__VITE_ASSET__oBrTlORz__";